import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import {connect} from "trim-redux";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import validator from "validator";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import Grid from "@material-ui/core/Grid/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import LoadingButton from "../../../components/elements/LoadingButton";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";

class ShippingConfirmationButton extends React.Component{
    state = {
        open: false,
        fields:{
            refrence:"",
            bank_name:"",
            account_number:"",
            sheba_number:"",
        },
        errors:{},
        SubmitLoading: false,
        editMode:false,
        id: this.props.item_id

    };

    toggleOpen(){
        this.setState({
            open: !this.state.open
        })
    }
    handleChange(e){
        let {errors,fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        errors[target.name] = "";
        this.setState({fields});
    }

    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //name
        if(validator.isEmpty(fields.refrence)){
            formIsValid = false;
            errors['refrence'] = Translate.emptyField;
        }
        if(validator.isEmpty(fields.sheba_number)){

        }else if(fields.sheba_number.length !== 24){
            formIsValid = false;
            errors['sheba_number'] = Translate.wrongSheba;
        }
        //name
        if(validator.isEmpty(fields.bank_name)){
            formIsValid = false;
            errors['bank_name'] = Translate.emptyField;
        }
        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                errors,
                SubmitLoading:false,
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        let { fields,id,editMode} = this.state;
        let data = new FormData();
        data.append('refrence', fields.refrence);
        data.append('bank_name', fields.bank_name);
        data.append('account_number', fields.account_number);
        data.append('sheba_number', fields.sheba_number);
        data.append('id', id);

        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/wallet/payed`, data, config)
            .then(response => {
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false,
                    open:false,
                });
                this.props.reload()
            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(editMode ?  Translate.dataEditingFailed : Translate.dataAddingFailed, {
                    variant: 'error',
                });
                this.setState({
                    loading:false,
                    SubmitLoading: false,
                    SubmitDraftLoading: false
                });
            });

    }
    handleSubmit(e){
        this.setState({
            SubmitLoading: true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    handleThumbImage(id){
        this.setState({
            logo: id
        })
    }
    render(){
        let {open,fields,errors,SubmitLoading} = this.state;
        let {user,setting} = this.props;
        let banks = setting.banks;
        return (
            <>
                <Button
                    color="primary"
                    onClick={() => this.toggleOpen()}
                    variant="contained"
                    style={{whiteSpace:"nowrap",marginTop:5,width:"100%"}}
                >
                    {Translate.paymentAction}
                </Button>
                <Dialog
                    open={open}
                    onClose={() => this.toggleOpen()}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle id="form-dialog-title">
                        <IconButton
                            onClick={() => this.toggleOpen()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                        {Translate.paymentAction}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} justify="center">
                            <Grid item xs={12}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    variant="outlined"
                                    name="refrence"
                                    label={Translate.transactionTrackingCode}
                                    type="text"
                                    value={fields.refrence}
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['refrence']}
                                    helperText={errors['refrence']}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    fullWidth
                                    variant="outlined"
                                    name="bank_name"
                                    label={Translate.bank_name}
                                    type="text"
                                    select
                                    value={fields.bank_name}
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['bank_name']}
                                    helperText={errors['bank_name']}
                                >
                                    {
                                        banks.map((item,index) => (
                                                <MenuItem key={index} value={item.description}>
                                                    {item.description}
                                                </MenuItem>
                                            )
                                        )
                                    }
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    name="sheba_number"
                                    type="number"
                                    label={Translate.sheba}
                                    value={fields.sheba_number}
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['sheba_number']}
                                    helperText={errors['sheba_number']}
                                    className="insta-field"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                IR
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    name="account_number"
                                    type="number"
                                    label={Translate.account_number}
                                    value={fields.account_number}
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['account_number']}
                                    helperText={errors['account_number']}
                                    className="insta-field"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                >
                                    {Translate.changeOrderStatus}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    user: state.user,
    setting:state.setting

});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ShippingConfirmationButton)))));